export const id_rsadsi = "1.2.840.113549";
export const id_pkcs = `${id_rsadsi}.1`;
export const id_pkcs_12 = `${id_pkcs}.12`;
export const id_pkcs_12PbeIds = `${id_pkcs_12}.1`;
export const id_pbeWithSHAAnd128BitRC4 = `${id_pkcs_12PbeIds}.1`;
export const id_pbeWithSHAAnd40BitRC4 = `${id_pkcs_12PbeIds}.2`;
export const id_pbeWithSHAAnd3_KeyTripleDES_CBC = `${id_pkcs_12PbeIds}.3`;
export const id_pbeWithSHAAnd2_KeyTripleDES_CBC = `${id_pkcs_12PbeIds}.4`;
export const id_pbeWithSHAAnd128BitRC2_CBC = `${id_pkcs_12PbeIds}.5`;
export const id_pbewithSHAAnd40BitRC2_CBC = `${id_pkcs_12PbeIds}.6`;
export const id_bagtypes = `${id_pkcs_12}.10.1`;
